module.exports = __webpack_public_path__ + "media/images/avatar-1-cb36aa278d051e3fa8cbe66b3fff0437.jpg";